import { render, staticRenderFns } from "./CrmLayout.vue?vue&type=template&id=42a82f16"
import script from "./CrmLayout.vue?vue&type=script&lang=js"
export * from "./CrmLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports